import { IconButton } from '@mui/material'
import { IconEyeClose, IconEyeOpen } from 'assets/icons'
import { MouseEvent } from 'react'

type Properties = {
  isVisible: boolean
  onClick: () => void
}

const preventDefault = (event: MouseEvent) => {
  event.preventDefault()
}

export const ToggleVisibilityButton = ({ isVisible, onClick }: Properties) => {
  return (
    <IconButton
      disableRipple
      onClick={onClick}
      onMouseDown={preventDefault}
      title={isVisible ? 'Hide password' : 'Show password'}
    >
      {isVisible ? <IconEyeOpen /> : <IconEyeClose />}
    </IconButton>
  )
}
